const breakpoints = [423, 768, 1280];

interface BreakpointMap {
  [key: string]: string;
}

type MinMax = 'min' | 'max';
type Key = `${MinMax}${number}`;
type MediaQuery = `@media (${MinMax}-width: ${number}px)`;

function keyAndMediaQuery(
  breakpoint: number,
  minOrMax: 'min' | 'max'
): [Key, MediaQuery] {
  const key: Key = `${minOrMax}${breakpoint}`;

  const mediaQuery: MediaQuery = `@media (${minOrMax}-width: ${breakpoint}px)`;

  return [key, mediaQuery];
}

const breakpointMap = breakpoints.reduce(
  (obj: BreakpointMap, bp: number): BreakpointMap => {
    const [maxKey, maxQuery] = keyAndMediaQuery(bp, 'max');
    const [minKey, minQuery] = keyAndMediaQuery(bp, 'min');

    obj[maxKey] = maxQuery;
    obj[minKey] = minQuery;

    return obj;
  },
  {}
);

export default breakpointMap;
